import { PRESET_COLORS_PRIMARY } from './colors.constants';

export const MAX_GROUP_COUNT = 500;

export const getRandomColor = (): string => PRESET_COLORS_PRIMARY[Math.floor(Math.random() * PRESET_COLORS_PRIMARY.length)] ?? PRESET_COLORS_PRIMARY[0];
